import React from 'react';
import { PublicFeed } from '@src/layouts';
import { LearningList, generateLearningFilters, SubnavWithPriceSlider } from '@src/features/feed';
import { getLearningPath, getLearningTopPicksPath } from '@src/services/board';
import { EmployerNav } from './organisms';

const Page = function() {
  return (
    <PublicFeed
      store="learningList"
      activeIndex={2}
      content={<LearningList {...{ getData: getLearningPath, getTopPicksData: getLearningTopPicksPath }} />}
      generateFilters={generateLearningFilters}
      header={<EmployerNav />}
      marginTop="75px"
      subnav={
        <SubnavWithPriceSlider
          {...{ activeIndex: 2, store: 'learningList', generateFilters: generateLearningFilters }}
        />
      }
    />
  );
};

export default Page;
